import { render, staticRenderFns } from "./pevisionnel-restauration.vue?vue&type=template&id=0b0bc81a"
import script from "./pevisionnel-restauration.vue?vue&type=script&setup=true&lang=js"
export * from "./pevisionnel-restauration.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports